import { LAYOUTS, TEACHER_ROLES } from "shared/constants";
import { myLessongroupsConversationsFragment } from "conversations/routes/fragments";
import type { AppRouteRecordRaw } from "shared/types";
import { getRememberedClassroomTab } from "./lastActiveTab";
import { LESSON_CLASS_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    path: "/my-lessongroups/:lessonClass",
    name: LESSON_CLASS_ROUTE_NAMES.MAIN,
    component: () => import("classroom/pages/LessonClassPage.vue"),
    meta: {
      title: "Mijn lesgroepen",
      roleRequired: TEACHER_ROLES,
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
    redirect: (to) => ({
      name:
        getRememberedClassroomTab("lesson") ??
        LESSON_CLASS_ROUTE_NAMES.STUDENTS,
      params: to.params,
    }),
    children: [
      {
        path: "students",
        name: LESSON_CLASS_ROUTE_NAMES.STUDENTS,
        component: () => import("classroom/pages/LessonClassStudentsPage.vue"),
        meta: {
          title: "Mijn lesgroepen",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "student-ratings",
        name: LESSON_CLASS_ROUTE_NAMES.STUDENT_RATINGS,
        component: () =>
          import("classroom/pages/LessonClassStudentMeetingPage.vue"),
        meta: {
          title: "Leerlingbespreking",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "advisory-ratings",
        name: LESSON_CLASS_ROUTE_NAMES.ADVISORY_RATINGS,
        component: () =>
          import("classroom/pages/LessonClassAdvisoryMeetingPage.vue"),
        meta: {
          title: "Adviesbespreking",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "group-ratings",
        name: LESSON_CLASS_ROUTE_NAMES.GROUP_RATINGS,
        component: () =>
          import("classroom/pages/LessonClassGroupMeetingPage.vue"),
        meta: {
          title: "Groepsbespreking",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "portfolio",
        name: LESSON_CLASS_ROUTE_NAMES.PORTFOLIO,
        component: () => import("classroom/pages/LessonClassPortfolioPage.vue"),
        meta: {
          title: "Portfolio",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "tasks",
        name: LESSON_CLASS_ROUTE_NAMES.TASKS,
        component: () => import("classroom/pages/LessonClassTasksPage.vue"),
        meta: {
          title: "Taken",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "learning-goals",
        name: LESSON_CLASS_ROUTE_NAMES.LEARNING_GOALS,
        component: () =>
          import("classroom/pages/LessonClassLearningGoalsPage.vue"),
        meta: {
          title: "Leerdoelen",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "actionplans",
        name: LESSON_CLASS_ROUTE_NAMES.ACTIONPLANS,
        component: () =>
          import("classroom/pages/LessonClassActionplanPage.vue"),
        meta: {
          title: "Actieplannen",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "conversations",
        name: LESSON_CLASS_ROUTE_NAMES.CONVERSATIONS,
        component: () =>
          import("classroom/pages/LessonClassConversationsPage.vue"),
        meta: {
          title: "Gesprekken",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      ...myLessongroupsConversationsFragment,
    ],
  },
];

export default routes;
